import {Request} from "../data/Request";

let TIMER = null;

export class Utils {

  static isFunction(value) {
    return typeof (value) === 'function';
  }

  static isString(value) {
    return typeof (value) === 'string';
  }

  static isNumber(value) {
    return typeof (value) === 'number';
  }

  static isBool(value) {
    return typeof (value) === 'boolean';
  }

  static isUndefOrNull(value) {
    return value === undefined || value === null;
  }

  static isSimpleType(value) {
    return Utils.isString(value) || Utils.isNumber(value) || Utils.isBool(value) ||
      Utils.isUndefOrNull(value);
  }

  static dashToCamelCase(str) {
    return str.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
  }

  static extractDate(str) {
    if (!str) {
      return null;
    }
    let res = str.match(/\d{4}-\d{2}-\d{2}/);
    return res !== null ? res[0] : null;
  }

  static splitDate(str) {
    if (!str) {
      return null;
    }
    let res = str.match(/(\d{4})-(\d{2})-(\d{2})/);
    return res === null ? null : {
      year: res[1],
      month: res[2],
      day: res[3],
    }
  }

  /**
   * Parse query strings from the given URL
   * @param [url]
   */
  static getQueryParams(url) {

    if (!url) url = window.location.search;
    let result = {};
    let hashes = url.slice(url.indexOf('?') + 1).split('&');

    for(let i = 0; i < hashes.length; i++) {
      let item = hashes[i].split('=');
      let key = item[0];
      let value = item.length === 1 ? true : item[1];
      if (result.hasOwnProperty(key)) {
        if (!Array.isArray(result[key])) {
          result[key] = [result[key]];
        }
        result[key].push(value);
      }
      else {
        result[key] = value;
      }
    }
    return result;
  }

  static insertPlaceholder(str, params) {
    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        str = str.replace('{' + key + '}', params[key]);
      }
    }
    return str;
  }

  static uploadFile(path, data) {

    let req = new Request({
      collection: 'assets/content',
      contentType: false,
      xhr: {
        crossDomain: true,
        cache: false,
        processData: false, // Don't process the files
      }
    });

    req.addHeader({
      'Cache-Control': 'no-cache, max-age=0',
      'If-Modified-Since': 'Sat, 1 Jan 2000 00:00:00 GMT'
    });

    return req.put(path, data);
  }

  static deleteFile(path) {

    let req = new Request({
      collection: 'assets/content'
    });

    return req.delete(path);
  }

  /**
   * Converts a data URL string to a Blob instance
   * @param dataURI
   * @return {Blob}
   */
  static dataURItoBlob(dataURI) {
    let bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
      atob(dataURI.split(',')[1]) :
      unescape(dataURI.split(',')[1]);
    let mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
    let max = bytes.length;
    let ia = new Uint8Array(max);
    for (let i = 0; i < max; i++)
      ia[i] = bytes.charCodeAt(i);
    return new Blob([ia], { type: mime });
  }

  static timeToLogout() {
    let date = new Date().getTime(),
      datePlusHour = date + 60 * 60 * 1000;

    clearInterval(TIMER);
    TIMER = window.setInterval(function() {
      let now = new Date(),
        distance = datePlusHour - now,
        minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if(minutes < 10) {
        minutes = minutes + ':' + seconds +' Min';
      } else {
        minutes = minutes + ' Min';
      }
      $(".logoutTime").text(`automatischer Logout in: ${minutes}`);

      if (distance <= 0) {
        clearInterval(TIMER);
        $(".js-user-logout").click();
      }}, 1000);
  }

  static getLastDayOfMonth( year, month ) {
    return new Date( year, month + 1, 0 ).getDate();
  }

  static generateWeek( date, returned = 0 ) {
    let helper = false;
    while( date.getDay() !== 1) {
      helper = true;
      date.setDate( date.getDate()+1 );
    }
    returned = helper ? returned : returned-7;
    date.setDate( date.getDate() - returned );
    return date;
  }
}
